/**
 * Convert an organization name (or any human string) into a URL-safe slug.
 * e.g. "Ummahfy" -> "ummahfy", "Al Madinah Center" -> "al-madinah-center"
 *
 * Lossy by design: kept simple so we can resolve back to a name on the
 * server by matching slugified names. If two organizations ever collide,
 * we'll need a real slug column on the Organization model.
 */
export function slugifyOrgName(name) {
  if (!name || typeof name !== 'string') return '';
  return name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Find an organization in a list by slug. Compares slugified names.
 */
export function findOrgBySlug(orgs, slug) {
  if (!Array.isArray(orgs) || !slug) return null;
  const target = slug.toLowerCase();
  return orgs.find((org) => slugifyOrgName(org?.name) === target) || null;
}
